export default "__VITE_PUBLIC_ASSET__05c5a60b__"